<template>
  <div>
    <div class="clients-tabs bg-white radius-7 mb-20">
      <div class="clients-tabs__list" role="tablist" aria-label="Clientes">
        <button
          v-for="tab in tabs"
          :key="tab.key"
          type="button"
          class="clients-tabs__button"
          :class="{ active: currentTab === tab.key }"
          role="tab"
          :aria-selected="currentTab === tab.key"
          :title="tab.title"
          @click="openTab(tab.key)"
        >
          <span>{{ tab.label }}</span>
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-xxl-12">
        <div v-if="currentTab === 'TC'">
          <ClientsList />
        </div>

        <div v-if="currentTab === 'QA'">
          <ClientsRankingQtdAttendant />
        </div>

        <div v-if="currentTab === 'VGA'">
          <ClientsRankingTotalValue />
        </div>

        <div v-if="currentTab === 'AMA'">
          <ClientsRankingLastAttendant />
        </div>

        <div v-if="currentTab === 'VGC'">
          <ClientsRankingTotalValueSold />
        </div>

        <div v-if="currentTab === 'VMA'">
          <ClientsRankingLastPurchase />
        </div>

        <div v-if="currentTab === 'AM'">
          <ClientsBirthdayMonth />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ClientsList from "../../components/Clients/ClientsList.vue";
import ClientsRankingQtdAttendant from "../../components/Clients/ClientsRankingQtdAttendant.vue";
import ClientsRankingTotalValue from "../../components/Clients/ClientsRankingTotalValue.vue";
import ClientsRankingTotalValueSold from "../../components/Clients/ClientsRankingTotalValueSold.vue";
import ClientsRankingLastAttendant from "../../components/Clients/ClientsRankingLastAttendant.vue";
import ClientsRankingLastPurchase from "../../components/Clients/ClientsRankingLastPurchase.vue";
import ClientsBirthdayMonth from "../../components/Clients/ClientsBirthdayMonth.vue";
import { mapActions } from "vuex";

export default defineComponent({
  name: "ClientsPage",
  components: {
    ClientsList,
    ClientsRankingQtdAttendant,
    ClientsRankingTotalValue,
    ClientsRankingLastAttendant,
    ClientsRankingTotalValueSold,
    ClientsRankingLastPurchase,
    ClientsBirthdayMonth,
  },
  data() {
    return {
      currentTab: "TC",
      loadedTabs: ["TC"] as string[],
      tabs: [
        { key: "TC", label: "Clientes", title: "Todos os Clientes" },
        { key: "QA", label: "QA", title: "Top 30 clientes (Qtd. Atendimentos)" },
        { key: "VGA", label: "VGA", title: "Top 30 clientes (Valor gasto - atendimento)" },
        { key: "AMA", label: "AMA", title: "Top 30 clientes (Atendimentos mais antigos)" },
        { key: "VGC", label: "VGC", title: "Top 30 clientes (Valor gasto em compras)" },
        { key: "VMA", label: "VMA", title: "Top 30 clientes (Vendas mais antigas)" },
        { key: "AM", label: "AM", title: "Aniversariantes do Mês" },
      ],
    };
  },
  methods: {
    ...mapActions([
      "fetchClientsRankingQtdAttendant",
      "fetchClientsRankingTotalValue",
      "fetchClientsRankingLastAttendant",
      "fetchClientsRankingTotalValueSold",
      "fetchClientsRankingLastPurchase",
      "fetchClientsBirthdayMonth",
    ]),
    openTab(tab: string) {
      this.currentTab = tab;

      if (!this.loadedTabs.includes(tab)) {
        this.loadedTabs.push(tab);

        switch (tab) {
          case "QA":
            this.fetchClientsRankingQtdAttendant();
            break;
          case "VGA":
            this.fetchClientsRankingTotalValue();
            break;
          case "AMA":
            this.fetchClientsRankingLastAttendant();
            break;
          case "VGC":
            this.fetchClientsRankingTotalValueSold();
            break;
          case "VMA":
            this.fetchClientsRankingLastPurchase();
            break;
          case "AM":
            this.fetchClientsBirthdayMonth();
            break;
        }
      }
    },
  },
  mounted() {
    // The main list (ClientsList) loads its data when mounted via v-if.
  },
});
</script>

<style scoped>
.clients-tabs {
  -ms-overflow-style: none;
  overflow-x: auto;
  padding: 8px;
  scrollbar-width: none;
}

.clients-tabs::-webkit-scrollbar {
  display: none;
}

.clients-tabs__list {
  display: flex;
  gap: 6px;
  min-width: max-content;
}

.clients-tabs__button {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: var(--splash-muted-color);
  display: inline-flex;
  font-size: 14px;
  font-weight: 700;
  gap: 8px;
  min-height: 42px;
  padding: 0 16px;
  transition: var(--transition);
  white-space: nowrap;
}

.clients-tabs__button:hover,
.clients-tabs__button.active {
  background: rgba(101, 96, 240, 0.1);
  color: var(--splash-primary-color);
}

@media (max-width: 767px) {
  .clients-tabs {
    margin-left: -4px;
    margin-right: -4px;
  }

  .clients-tabs__button {
    font-size: 13px;
    min-height: 40px;
    padding: 0 12px;
  }
}
</style>

<style>
body.dark .clients-tabs__button:hover,
body.dark .clients-tabs__button.active {
  background: rgba(167, 164, 255, 0.16);
  color: #a7a4ff;
}
</style>
